import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AuthProtectedRoutePropsType } from "./AuthProtectedRouteTypes";
import { useSiteData } from "./SiteDataContext";

export const AuthProtectedRoute: React.FC<AuthProtectedRoutePropsType> = ({
  children,
}) => {
  const { authState } = useSiteData();
  const location = useLocation();

  if (authState.isLoading) {
    return <div data-testid="loading">Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login9M3F5F" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
